<div
  class="mission-card"
  [style]="
    isChecked
      ? {
          'background-image': 'url(../../../../assets/icons/check.svg)',
          'background-repeat': 'no-repeat',
          'background-size': '50%',
          'background-position-y': 'center',
          'background-position-x': '150px',
          'background-color': '#D6E1BF',
        }
      : ''
  "
>
  <div class="profile">
    <img
      *ngIf="missionData?.attributes?.person?.data?.attributes?.profilePicture?.data?.attributes?.url"
      src="{{ env.strapi.strapiRootUrl + missionData?.attributes?.person?.data?.attributes?.profilePicture?.data?.attributes?.url }}"
      alt="profile"
    />
  </div>

  <div class="content">
    <div class="name" [style]="{ color: '#' + missionData?.attributes?.person?.data?.attributes?.nameColor }">
      {{ missionData?.attributes?.person?.data?.attributes?.name }}
    </div>
    <div class="todo">{{ missionData?.attributes?.cardTitle }}</div>
  </div>
</div>
